import { SPLIT_ORDER } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case SPLIT_ORDER:
      return action.payload
    default:
      return state
  }
}
